import { render, staticRenderFns } from "./QNATable.vue?vue&type=template&id=4cdba62e"
import script from "./QNATable.vue?vue&type=script&lang=js"
export * from "./QNATable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports